//import Vue from 'vue'
const state = {
    title: "",
    visible: false
}
// getters
const getters = {}

// actions
const actions = {
    showLoader({ commit }, data) {
        commit('showLoader', data)
    },
    setLoaderTitle({ commit }, data) {
        commit('setLoaderTitle', data)
    }
}

// mutations
const mutations = {
    showLoader(state, playload) {
        state.visible = playload
    },
    setLoaderTitle(state, playload){
        state.title = playload
    }
}

export default {
    namespaced: false,
    state,
    getters,
    actions,
    mutations
}